module.exports = __webpack_public_path__ + "step2.4f9e08d400adbfd9a2287f9db0c7b5fb.png";